module.exports = __webpack_public_path__ + "static/media/sell_finish_service_help_4.086a8452.jpg";